// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1Mb1_","title":"Info_title__3zE7m","links":"Info_links__3mAeR","link":"Info_link__23kPB","logo":"Info_logo__3NNWJ"};